<template>
  <div id="DeskLeftView">
    <div class="DeskLeftContent">
      <div class="Content">
        <!-- 校园心理健康相关服务 -->
        <!-- <div class="serveDiv">
          <div class="serveLfet">
            <h2>
              我们提供更多
              <b>校园心理健康相关服务</b>
            </h2>
            <p>心理辅导室建设、心理咨询专业技能培训、心理团辅教具教案<br>提供线上评估、线下访谈以及团辅个辅服务</p>
            <img src="@/assets/servebtn.png" alt="" @click="serveClick" style="margin-bottom: 12px;cursor: pointer;">
          </div>
          <div class="serveRight">
            <img src="@/assets/servePng.png" alt="">
          </div>
        </div> -->
        <!-- 正在进行的教育局任务 -->
        <div class="EducationTask" v-if="teacherAdmin.jw_enable && questionnairenTaskNew">
          <a-card size="small" title="正在进行的教育局任务">
            <div v-if="questionnairenTaskNew">
              <!-- 父任务 -->
              <div class="ParentTask">
                <a-progress type="circle" :percent="parseFloat(questionnairenTaskNew.progress.toFixed(2))" :width="80" />
                <div>
                  <h3>{{questionnairenTaskNew.TASK_NAME}}</h3>
                  <ul>
                    <li>
                      <span>开始时间</span>
                      <b>{{questionnairenTaskNew.TASK_START_DATE}}</b>
                    </li>
                    <li>
                      <span></span>
                      <b>————</b>
                    </li>
                    <li>
                      <span>结束时间</span>
                      <b>{{questionnairenTaskNew.TASK_END_DATE}}</b>
                    </li>
                    <li>
                      <span>任务状态</span>
                      <b v-if="(new Date() > new Date(this.questionnairenTaskNew.TASK_START_DATE.replace(/-/g, '/'))) && (new Date(new Date() - 24 * 60 * 60 * 1000) < new Date(this.questionnairenTaskNew.TASK_END_DATE.replace(/-/g, '/')))">进行中</b>
                      <b v-else>已结束</b>
                    </li>
                  </ul>
                </div>
              </div>
              <!-- 子任务 -->
              <div class="SubTask" v-if="questionnairenTaskNew && questionnairenTaskNew.CHILDREN && questionnairenTaskNew.CHILDREN.length">
                <a-table bordered :dataSource="questionnairenTaskNew.CHILDREN | filtersTextChange" :columns="columns" :pagination="false" :rowKey="row => row.ID">
                  <div slot="TASK_NAME" slot-scope="text">
                    <img src="@/assets/desk3.png" alt="">
                    <b style="font-weight: normal;">{{text}}</b>
                  </div>
                  <div slot="PROGRESS" slot-scope="text, record">
                    <a-progress :percent="parseFloat(record.PROGRESS.toFixed(2))" :strokeWidth="6" />
                    <span v-if="record.STATUS === 0 && (new Date(new Date() - 24 * 60 * 60 * 1000) < new Date(record.TASK_END_DATE.replace(/-/g, '/')))" style="color: #8C8C8C;">待分发</span>
                    <span v-if="record.STATUS !== 0 && (new Date(new Date() - 24 * 60 * 60 * 1000) < new Date(record.TASK_END_DATE.replace(/-/g, '/'))) && (parseInt(record.PROGRESS) !== 100)" style="color: #595959">进行中</span>
                    <span v-if="(new Date(new Date() - 24 * 60 * 60 * 1000) > new Date(record.TASK_END_DATE.replace(/-/g, '/'))) || (parseInt(record.PROGRESS) === 100)">已结束</span>
                  </div>
                  <div slot="operation" slot-scope="text, record">
                    <span style="color: #1890FF;" v-if="((new Date(new Date() - 24 * 60 * 60 * 1000) > new Date(record.TASK_END_DATE.replace(/-/g, '/'))) || (new Date(new Date() - 24 * 60 * 60 * 1000) < new Date(record.TASK_END_DATE.replace(/-/g, '/'))) || (parseInt(record.PROGRESS) === 100)) && record.STATUS !== 0" @click="viewUndetect(record)">
                      <a-button :disabled="(parseInt(record.PROGRESS) === 100)" style="background: transparent;border: 0px;">查看未测</a-button>
                    </span>
                    <template v-if="record.STATUS === 0">
                      <button v-if="roleID === 1" :disabled="!(new Date(new Date() - 24 * 60 * 60 * 1000) < new Date(record.TASK_END_DATE.replace(/-/g, '/')))" style="color: #1890FF;cursor: pointer;background: transparent;border: 0px;" @click="goto" :class="(new Date(new Date() - 24 * 60 * 60 * 1000) < new Date(record.TASK_END_DATE.replace(/-/g, '/'))) ? '' : 'overdue'">去分发</button>
                      <a-tooltip v-else class="showHide">
                        <template slot="title">仅限超级管理员使用</template>
                        去分发
                      </a-tooltip>
                    </template>
                  </div>
                </a-table>
              </div>
            </div>
            <div v-else class="noTask">
              <img src="@/assets/desk6.png" alt="">
              <span>暂无进行中的教育局任务</span>
            </div>
          </a-card>
        </div>
        <div class="serviceCard" style="margin-bottom: 16px;">
          <a-card size="small" title="更多校园心理健康服务">
            <div>
              <img src="@/assets/service5.png" alt="">
              <div>
                <b>学生幸福心理课</b>
                <p>清华大学社会科学学院积极心理学研究中</p>
                <p>心研发，适合各学段的积极心理课程体系</p>
                <span onclick= "window.open('http://help.ceping525.com/2022/11/02/%e5%ad%a6%e7%94%9f%e5%b9%b8%e7%a6%8f%e5%bf%83%e7%90%86%e8%af%be/')">查看详情</span>
              </div>
            </div>
            <div>
              <img src="@/assets/service6.png" alt="">
              <div>
                <b>校园身心健康智能穿戴方案</b>
                <p>智能身心健康手表，让运动、睡眠与心理</p>
                <p>可测量和计算</p>
                <span onclick= "window.open('http://help.ceping525.com/2022/11/04/%e6%a0%a1%e5%9b%ad%e8%ba%ab%e5%bf%83%e5%81%a5%e5%ba%b7%e6%99%ba%e8%83%bd%e7%a9%bf%e6%88%b4%e6%96%b9%e6%a1%88/')">查看详情</span>
              </div>
            </div>
            <div>
              <img src="@/assets/service7.png" alt="">
              <div>
                <b>家校积极教育主题培训</b>
                <p>面向中小学教师的积极心理学系统培训，</p>
                <p>涵盖情绪、关系、意义等八大主题</p>
                <span onclick= "window.open('http://help.ceping525.com/2022/11/03/%e5%ae%b6%e6%a0%a1%e7%a7%af%e6%9e%81%e6%95%99%e8%82%b2%e4%b8%bb%e9%a2%98%e5%9f%b9%e8%ae%ad/')">查看详情</span>
              </div>
            </div>
            <div>
              <img src="@/assets/service1.png" alt="">
              <div>
                <b>学校心理辅导室建设指南</b>
                <p>帮助您更好的规划学校心理辅导室</p>
                <p>有效提高学校心理健康工作开展效率</p>
                <span onclick= "window.open('http://help.ceping525.com/2021/10/11/%e5%ad%a6%e6%a0%a1%e5%bf%83%e7%90%86%e8%be%85%e5%af%bc%e5%ae%a4%e5%bb%ba%e8%ae%be%e6%8c%87%e5%8d%97/')">查看详情</span>
              </div>
            </div>
            <div>
              <img src="@/assets/service3.png" alt="">
              <div>
                <b>心理团辅教具教案工具包</b>
                <p>精心设计的心理主题班会课与</p>
                <p>心理团体活动课工具包</p>
                <span onclick= "window.open('http://help.ceping525.com/2021/10/09/%e5%bf%83%e7%90%86%e5%81%a5%e5%ba%b7%e6%95%99%e8%be%85%e5%b7%a5%e5%85%b7%e5%8c%85/')">查看详情</span>
              </div>
            </div>
            <div>
              <img src="@/assets/service4.png" alt="">
              <div>
                <b>《青少年成长测评与辅导》培训</b>
                <p>绿萝心数联合中国心理卫生协会推出专项</p>
                <p>培训</p>
                <span onclick= "window.open('http://help.ceping525.com/2021/11/06/%e5%bf%83%e7%90%86%e5%92%a8%e8%af%a2%e5%b8%88%e5%9f%ba%e7%a1%80%e5%9f%b9%e8%ae%ad/')">查看详情</span>
              </div>
            </div>
          </a-card>
        </div>
        <!-- 正在进行的校内测评 -->
        <div class="SchoolEvaluation">
          <a-card size="small" title="正在进行的校内测评">
            <div v-if="teacherAdmin.kaitong" class="SchoolEvaluationProgress">
              <school-assessment></school-assessment>
            </div>
            <div v-else class="SchoolEvaluationAdvertise" style="text-align: center;font-size: 12px;color: #8C8C8C;">
              <img src="@/assets/desk6.png" style="width: 64px; height: auto; margin-top: 8px; margin-bottom: 17px" />
              暂无进行中的校内测评
              <!-- <div>
                  <img src="@/assets/desk2.png" alt="">
                  <div>
                    <h2>开通学校自有账户，享受心理健康校园</h2>
                    <div>
                      <span><img src="@/assets/desk3.png" alt="">70+量表</span>
                      <span><img src="@/assets/desk4.png" alt="">10+游戏</span>
                    </div>
                  </div>
              </div>
              <img src="@/assets/desk5.png" alt=""> -->
            </div>
          </a-card>
        </div>
      </div>
    </div>
    <div class="taskDetail" v-if="taskDetailData">
      <a-drawer
        wrapClassName="wrapModalUndetected"
        width="1000"
        :closable="false"
        :visible="visible"
        @close="close"
      >
        <modal-undetected :taskDetailData="taskDetailData" @close="close"></modal-undetected>
      </a-drawer>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions, mapMutations } from 'vuex'
  import SchoolAssessment from '@/components/DeskDetail/SchoolAssessment'
  import ModalUndetected from '@/components/Evaluation/Education/ModalUndetected'
  export default {
    name: 'DeskLeftView',
    props: [
      'teacherAdmin'
    ],
    components: {
      SchoolAssessment,
      ModalUndetected
    },
    data () {
      return {
        questionnairenTaskNew: null,
        taskDetailData: null,
        visible: false,
        gradeList: null,
        columns: [
          {
            title: '子任务名称',
            dataIndex: 'TASK_NAME',
            width: '25%',
            scopedSlots: { customRender: 'TASK_NAME' },
          },
          {
            title: '子任务进度',
            dataIndex: 'PROGRESS',
            width: '55%',
            scopedSlots: { customRender: 'PROGRESS' }
          },
          {
            title: '操作',
            key: 'operation',
            scopedSlots: { customRender: 'operation' }
          },
        ],
        roleID: null
      }
    },
    computed: {
      ...mapState([
        'questionnairenTask',
        'schoolInfos',
        'getSchoolTaskScale',
        'getSchoolTaskGame'
      ])
    },
    filters: {
      filtersTextChange (questionnairenTask) { // 过滤出可以开始测评的子任务
        let data = []
        questionnairenTask.map((task) => {
          if (new Date() > new Date(task.TASK_START_DATE.replace(/-/g, '/'))) {
            data.push(task)
          }
        })
        return data
      }
    },
    methods: {
      ...mapMutations([
      'setNavNum'
      ]),
      ...mapActions([
        'getUnfinishedStudents',
        'getGame',
        'getQuestionnairenTask'
      ]),
      serveClick () {
        window.open('http://help.ceping525.com/category/%e8%b5%84%e6%ba%90%e6%89%a9%e5%b1%95/')
      },
      async viewUndetect (item) { // 查看未测
        console.log(item)
        this.taskDetailData = item
        this.visible = true
        await this.gradesFun(item)
        if (item) {
          if (item.GROUP_TYPE === 1) { // 量表
            let SURVEY_LIST = []
            item.SURVEY_LIST.map(value => {
              SURVEY_LIST.push(value.SID)
            })
            sessionStorage.setItem('SURVEY_LIST', JSON.stringify(SURVEY_LIST))
            await this.getUnfinishedStudents({gradeList: this.gradeList, item})
          } else if (item.GROUP_TYPE === 2) { // 游戏
            await this.getGame()
          }
        }
      },
      close () {
        this.visible = false
      },
      async gradesFun (item) { // 整合任务覆盖的班级年级、获取当前任务的DQID
        this.gradeList = []
        // console.log(item.GRADE_LIST.split(','))
        if (item) {
          item.GRADE_LIST.split(',').map((list) => {
            this.schoolInfos.map((info) => {
              if (parseInt(list) === info.ENTRYYEAR) {
                this.gradeList.push({grade_id: parseInt(list), class_id: info.CLASS_ID})
              }
            })
          })
        }
      },
      async publicFun () { // 更新教育局任务
        if (this.questionnairenTask.length) {
          let taskNew = this.questionnairenTask.sort((a, b) => { // 取最新的教育局任务
            return b.ID - a.ID
          })[0]
          if ((new Date() > new Date(taskNew.TASK_START_DATE.replace(/-/g, '/'))) && (new Date(new Date() - 24 * 60 * 60 * 1000) < new Date(taskNew.TASK_END_DATE.replace(/-/g, '/')))) { // 判断教育局任务是否开始
            this.questionnairenTaskNew = taskNew
          }
        }
      },
      goto () { // 去分发
        this.setNavNum(2)
        this.$router.push('/evaluationList/taskManage')
      }
    },
    async mounted () {
      this.roleID = JSON.parse(sessionStorage.getItem('userInfo')).role_id
      if (this.teacherAdmin.jw_enable) {
        await this.getQuestionnairenTask()
        if (this.questionnairenTask) {
          this.publicFun()
        }
      }
    }
  }
</script>

<style>
  #DeskLeftView {
    flex: 1;
    color: #262626;
  }
  #DeskLeftView .DeskLeftContent {
    width: 100%;
    padding-right: 24px;
  }
  #DeskLeftView .DeskLeftContent .Content {
    width: 100%;
    padding-bottom: 20px;
  }
  #DeskLeftView .DeskLeftContent .Content .serviceCard .ant-card-body {
    display: flex;
    flex-wrap: wrap;
    padding: 24px 43px;
    box-sizing: border-box;
  }
  #DeskLeftView .DeskLeftContent .Content .serviceCard .ant-card-body > div {
    flex-basis: 50%;
    display: flex;
    align-items: flex-start;
  }
  #DeskLeftView .DeskLeftContent .Content .serviceCard .ant-card-body > div {
    padding-bottom: 32px;
  }
  #DeskLeftView .DeskLeftContent .Content .serviceCard .ant-card-body > div:last-child, #DeskLeftView .DeskLeftContent .Content .serviceCard .ant-card-body > div:nth-child(5) {
    padding-bottom: 0px;
  }
  #DeskLeftView .DeskLeftContent .Content .serviceCard .ant-card-body > div img {
    width: 45px;
    height: auto;
    margin-right: 27px;
    margin-top: 6px;
  }
  #DeskLeftView .DeskLeftContent .Content .serviceCard .ant-card-body > div:nth-child(1) img {
    width: 42px;
    margin-top: 3px;
  }
  #DeskLeftView .DeskLeftContent .Content .serviceCard .ant-card-body > div:nth-child(3) img {
    width: 41px;
  }
  #DeskLeftView .DeskLeftContent .Content .serviceCard .ant-card-body > div b {
    display: inline-block;
    margin-bottom: 16px;
    font-size: 16px;
    line-height: 16px;
    color: #262626;
  }
  #DeskLeftView .DeskLeftContent .Content .serviceCard .ant-card-body > div p {
    padding: 0px;
    margin-bottom: 8px;
    line-height: 14px;
    font-size: 14px;
    color: rgba(23, 26, 29, 0.6);
  }
  #DeskLeftView .DeskLeftContent .Content .serviceCard .ant-card-body > div span {
    display: inline-block;
    cursor: pointer;
    margin-top: 16px;
    font-size: 14px;
    color: #0089FF;
  }
  #DeskLeftView .DeskLeftContent .Content .ant-card {
    width: 100%;
  }
  #DeskLeftView .DeskLeftContent .Content .ant-card .ant-card-head-title {
    color: #262626;
    font-size: 14px;
    font-weight: bold;
    padding: 16px 12px 16px 12px;
    box-sizing: border-box;
  }
  #DeskLeftView .DeskLeftContent .Content .EducationTask {
    margin-bottom: 20px;
  }
  #DeskLeftView .DeskLeftContent .Content .ant-progress-success-bg, .ant-progress-bg, #DeskLeftView .DeskLeftContent .Content .ant-progress-circle-path {
    background: #51BF94;
    stroke: #51BF94!important;
  }
  #DeskLeftView .DeskLeftContent .Content .EducationTask .ant-card-small > .ant-card-body {
    padding: 0px;
  }
  #DeskLeftView .DeskLeftContent .Content .EducationTask .ParentTask {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 32px 24px;
    box-sizing: border-box;
  }
  #DeskLeftView .DeskLeftContent .Content .EducationTask .ParentTask>div h3 {
    font-size: 18px;
    font-weight: normal;
    margin-bottom: 0px;
  }
  #DeskLeftView .DeskLeftContent .Content .EducationTask .ParentTask>div:last-child {
    margin-left: 32px;
  }
  #DeskLeftView .DeskLeftContent .Content .EducationTask .ParentTask>div ul {
    display: flex;
    padding-left: 0px;
  }
  #DeskLeftView .DeskLeftContent .Content .EducationTask .ParentTask>div ul li {
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    margin-right: 20px;
  }
  #DeskLeftView .DeskLeftContent .Content .EducationTask .ParentTask>div ul li span {
    font-size: 12px;
    color: #8C8C8C;
    padding: 12px 0px;
  }
  #DeskLeftView .DeskLeftContent .Content .EducationTask .ParentTask>div ul li b {
    font-size: 14px;
    color: #262626;
    font-weight: normal;
  }
  #DeskLeftView .DeskLeftContent .Content .EducationTask .ParentTask>div ul li:last-child {
    margin-left: 70px;
    margin-right: 0px;
  }
  #DeskLeftView .DeskLeftContent .Content .EducationTask .SubTask .ant-table-tbody > tr:last-child > td {
    border: 0px;
  }
  #DeskLeftView .DeskLeftContent .Content .EducationTask .SubTask .ant-table-thead > tr > th, #DeskLeftView .DeskLeftContent .Content .EducationTask .SubTask .ant-table-tbody > tr > td {
    border-left: 0px;
    border-right: 0px;
    padding-left: 24px;
    font-size: 14px;
    color: #262626;
  }
  #DeskLeftView .DeskLeftContent .Content .EducationTask .SubTask .ant-table-thead > tr > th {
    color: #8C8C8C;
    font-size: 12px;
  }
  #DeskLeftView .DeskLeftContent .Content .EducationTask .SubTask .ant-table-tbody > tr > td > div {
    display: flex;
    align-items: center;
  }
  #DeskLeftView .DeskLeftContent .Content .EducationTask .SubTask .ant-table-tbody > tr > td > div .ant-progress {
    width: 60%;
    margin-right: 50px;
  }
  #DeskLeftView .DeskLeftContent .Content .EducationTask .SubTask .ant-table-tbody > tr > td img {
    margin-right: 12px;
  }
  #DeskLeftView .DeskLeftContent .Content .EducationTask .SubTask .ant-table-tbody > tr > td button {
    padding: 0px;
    color: #1890FF;
  }
  #DeskLeftView .DeskLeftContent .Content .EducationTask .noTask {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    color: #8C8C8C;
    padding: 48px 0px 40px;
  }
  #DeskLeftView .DeskLeftContent .Content .EducationTask .noTask img {
    width: 64px;
    height: auto;
    margin-bottom: 17px;
  }
  #DeskLeftView .DeskLeftContent .Content .SchoolEvaluation .SchoolEvaluationAdvertise {
    padding: 28px 12px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    /* 暂时 */
    flex-direction: column;
    padding: 40px 0px;
  }
  #DeskLeftView .DeskLeftContent .Content .SchoolEvaluation .SchoolEvaluationAdvertise>div {
    display: flex;
    align-items: center;
    padding-left: 14px;
    box-sizing: border-box;
  }
  #DeskLeftView .DeskLeftContent .Content .SchoolEvaluation .SchoolEvaluationAdvertise>div>img {
    width: 55px;
    height: auto;
    margin-right: 38px;
  }
  #DeskLeftView .DeskLeftContent .Content .SchoolEvaluation .SchoolEvaluationAdvertise>div h2 {
    font-size: 24px;
    color: #333333;
    margin-bottom: 23px;
    display: -webkit-box;    
    -webkit-box-orient: vertical;    
    -webkit-line-clamp: 1;    
    overflow: hidden;
  }
  #DeskLeftView .DeskLeftContent .Content .SchoolEvaluation .SchoolEvaluationAdvertise>div span:first-child {
    margin-right: 35px;
  }
  #DeskLeftView .DeskLeftContent .Content .SchoolEvaluation .SchoolEvaluationAdvertise>div span img {
    margin-right: 8px;
  }
  #DeskLeftView .DeskLeftContent .Content .SchoolEvaluation .SchoolEvaluationAdvertise>div span:first-child img {
    width: 12px;
    height: auto;
  }
  #DeskLeftView .DeskLeftContent .Content .SchoolEvaluation .SchoolEvaluationAdvertise>div span:last-child img {
    width: 16px;
    height: auto;
  }
  #DeskLeftView .DeskLeftContent .Content .SchoolEvaluation .SchoolEvaluationAdvertise>img {
    width: 12px;
    height: auto;
  }
  #DeskLeftView .DeskLeftContent .overdue, #DeskLeftView .DeskLeftContent .showHide {
    color: #BFBFBF!important;
  }
</style>
